module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sgc-toc-title"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/dedication#urbDHPXfkJglm5sV43yPgk7"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chap_01#uxpzOuqAjbtsfPbxrRDsce6"
    }
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chap_02#utkDrn8F3sTavmDl8MycmK8"
    }
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chap_03#uuLdIDJLky6Py3VUGjqPOHA"
    }
  }, [_vm._v("Chapter Three")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chap_04#udPHdv2JDwlGs4L4ZhOjd39"
    }
  }, [_vm._v("Chapter Four")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chap_05#u6DJlUowpL3suhZVFM5e2N8"
    }
  }, [_vm._v("Chapter Five")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_06#uuIrOX77254vGNhCzelFlZB",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_07#ucrYph562Z5UuboxSnDoDx3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_08#uzrPuFWohJXcW6om7GhHWCE",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_09#ujNBquuMUlBcH8vxX75CP8F",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_10#uOjTYyr5Cdalilj2hTJ87PD",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_11#uH7nmFk7z8ypegd5onoshSE",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_12#uFpb7biaiNwjciNhM2ksBm6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twelve")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_13#ueQYTcMbAikKkPwqPKNWlQB",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirteen")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_14#uw6AH8F5C4KAmoSSF3xLxCC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fourteen")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_15#usF26UsHXQuVKIQMnTOgxh7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifteen")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_16#ulV9TXEoDQFc7hSW6Jhsc6G",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Sixteen")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_17#uyQLFdXHxturVXtHLrrtSF4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seventeen")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_18#ugt7Gx5B6VdNcdEkTRTXj8G",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eighteen")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_19#uLRt5zFFeCHQ2vKvkG6Nll2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nineteen")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_20#ufswqp5KmYyAkgBlgxdOxn6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_21#uY9lUu2onqfVt4XI4rETDW4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-One")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_22#usdDM25T7QjkVILYZQW3aE6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Two")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_23#uc8ujir4WPB7DBCcUZ94L6C",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Three")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_24#uDk7UdBMPsoH5yTQMIVyvyF",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Four")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_25#uDNgpnYjtk2v5eVBu3JA4b2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Five")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_26#ubJPHUrXCrbfvUqdQFfpRIF",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Six")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_27#uFVp8XS2ew5zNkSttvsAhC4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Seven")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap_28#uGsA2snncvr5CAHLvkDquvE",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Eight")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Epilogue#uI9oSOCIqKxvgbE6YH6xLXB",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EPILOGUE")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24614150","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/TOC.vue
// module id = 66
// module chunks = 0